import React, {Component} from 'react';
import ReactMarkdown from 'react-markdown';
import readme from './GETTING_STARTED.md';

import components from '../../styles/_vars.scss';

// todo: should get this information out of a remote README.md
export default class GettingStarted extends Component {
  render() {
    return (
      <div className={[components.page]}>
        <ReactMarkdown source={readme}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/GettingStarted/index.js